import React from 'react';
import { useSelector } from 'react-redux';
import { selectData } from '../pages/homeSlice';
import styled from 'styled-components';
// Icons
import { FaEnvelope, FaGithub } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';

const StyledSocialLinks = styled.div`
	a {
		margin: 0 1rem;
		font-size: 2.5rem;
	}
`;

export default function SocialLinks() {
	const { html_url } = useSelector(selectData);

	return (
		<StyledSocialLinks>
			<a href='https://www.linkedin.com/in/chadvidovcich/' target='_blank' rel='noopener noreferrer' aria-label='Check out my LinkedIn profile.' className='link-icons'>
				<FaLinkedin />
			</a>
			<a href={html_url} target='_blank' rel='noopener noreferrer' aria-label='Check out my GitHub profile.' className='link-icons'>
				<FaGithub />
			</a>
			<a href='mailto:ChadVidovcich@gmail.com' aria-label='Send me an email.' className='link-icons'>
				<FaEnvelope />
			</a>
		</StyledSocialLinks>
	);
}
